<template>
  <div>
    <div v-html="boldenText"></div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, computed } from 'vue';

export default defineComponent({
  name: 'BoldMatcher',
  props: {
    text: {
      type: String,
      required: true,
    },
    pattern: {
      type: String,
      required: true,
    },
    color: {
      type: String,
      default: () => '',
    },
  },
  setup(props) {
    const boldenText = computed(() => {
      // 使用正则表达式找到所有匹配项
      const regex = new RegExp(`(${props.pattern})`, 'g');
      // 使用replace方法将匹配项包裹在<b>标签中
      if (!props.text) {
        return '';
      }
      return props.text?.replace(
        regex,
        `<span style='font-weight: 700; color: ${props.color}'>$&</span>`,
      );
    });

    return {
      boldenText,
    };
  },
});
</script>
